import urlTemplate from 'url-template'
import { isEmpty } from 'lodash'
import { clone } from 'ramda'
import { formatNumber } from './helpers'
import { prefixLanguage } from './urls'
import { i18n } from '@/i18n'


const { t } = i18n.global
interface SelectedFilterValue {
  title: string
  slug: string
}

interface Dependency {
  field: string
  key: string
  value: keyof SelectedFilterValue
}

interface FilterOption {
  keyFilter: string
  title: string
  type: 'checkbox' | 'autocomplete-checkbox' | 'select' | 'autocomplete-select' | 'range-single' | 'range' | 'switch'
  depends?: Dependency[]
  default?: boolean | null
  isDynamic?: boolean
  config?: {
    multiple: boolean
    requiredFormat?: boolean
  }
}

interface SelectedFilters {
  [key: string]: SelectedFilterValue | SelectedFilterValue[] | [number, number] | null | undefined
}

interface Tag {
  title: string
  type: FilterOption['type']
  label: string
  slug?: string
  isDynamic?: boolean
  config?: FilterOption['config']
  attr?: {
    title: string
    label?: string
    slug?: string
  }
}

interface City {
  title: string
  slug: string
}

const filterUrl = urlTemplate.parse('/{/filters*}/')

export function friendlyUrlParser() {
  let path = window.location.pathname
  const zero = 0
  const parsedUrl: Record<string, string[]> = {}
  if (path.indexOf('filters') > zero) {
    path = path.split('/page')[0]
    const hashes = path.split('filters/')[1].split('/')
    hashes.map((hash) => {
      const [key] = hash.split(':')
      let val: string | string[]
      [, val] = hash.split(':')

      parsedUrl[key] = []

      if (val) {
        if (val.indexOf(',') > zero) {
          val = val.split(',')
          val.forEach((v) => {
            if (v.indexOf('/') > zero) {
              parsedUrl[key].push(decodeURIComponent(v.split('/')[zero]))
            } else {
              parsedUrl[key].push(decodeURIComponent(v))
            }
          })
        } else if (val.indexOf('/') > zero) {
          parsedUrl[key].push(decodeURIComponent(val.split('/')[zero]))
        } else {
          parsedUrl[key].push(decodeURIComponent(val))
        }
      }
    })
  }
  return parsedUrl
}
// export function friendlyUrlParser(splittedPart: string) {
//   let path = decodeURIComponent(new URL(window.location.href).toString());
//   const zero = 0;
//   let page = 1
//   // let p = ''
//   const parsedUrl: Record<string, string[]> = {};
//   const [pathWithoutPage, p = ''] = path.split('/page');
//   if (p) {
//     page = Number(p.split('/')?.[1]) || page;
//   }
//   if (pathWithoutPage && pathWithoutPage.includes(splittedPart)) {
//     [, path] = pathWithoutPage.split(splittedPart);
//     if (!path) {
//       return { parsedUrl, page };
//     }
//     const hashes = path.split('/')[0].split(';').filter(hash => !!hash);
//     hashes.map(hash => {
//       let val: string | string[]
//       const [key] = hash.split('=');
//       [, val] = hash.split('=');

//       parsedUrl[key as string] = [];
//       if (val && val.includes(',')) {
//         val = val.split(',');
//         val.forEach(v => {
//           if (v.includes('/')) {
//             parsedUrl[key].push(decodeURIComponent(v.split('/')[zero]));
//           } else {
//             parsedUrl[key].push(decodeURIComponent(v));
//           }
//         });
//       } else if (val && val.includes('/')) {
//         parsedUrl[key].push(decodeURIComponent(val.split('/')[zero]));
//       } else {
//         parsedUrl[key].push(decodeURIComponent(val));
//       }
//       return { parsedUrl, page };
//     });
//   }
//   return { parsedUrl, page };
// }

export function updateFilterUrl(params, base) {
  let fullUrl = base

  const zero = 0
  const length = 2

  if (params.filters) {
    const keys = Object.keys(params.filters)

    for (let x = 0; x <= keys.length; x++) {
      if (params.filters[keys[x]] !== undefined) {
        if (zero === params.filters[keys[x]].length) {
          delete params.filters[keys[x]]
        }
      }
    }
  }

  let url = filterUrl.expand(params)

  url = url.replace(/;/, '')
  url = url.replace(/\//, '')
  url = url.replace(/%2C/g, ',')
  url = url.replace(/=/g, ':')

  if (params.label) {
    fullUrl = `${fullUrl}${params.label}/`
  }

  if (url.length > length) {
    fullUrl += `filters${url}`
  }

  if (params.pagination.page && params.pagination.page !== 1) {
    fullUrl = `${fullUrl}page/${params.pagination.page}/`
  }
  // Add page to URL if pagination uses limit-offset parameters
  // if (
  //   params.pagination &&
  //   typeof params.pagination.offset === 'number' &&
  //   typeof params.pagination.limit === 'number'
  // ) {
  //   const page = Math.floor(params.pagination.offset / params.pagination.limit) + 1
  //   if (page > 1) {
  //     fullUrl = `${fullUrl}page/${page}/`
  //   }
  // }
  fullUrl = prefixLanguage(fullUrl)
  window.history.pushState({ url: fullUrl }, '', fullUrl)
}

export const prepareFilters = (
  values: Record<string, any>,
  filters: { 
    keyFilter: string,
    type: string
    config?: { 
      multiple?: boolean
      label?: string
    }
  }[]
) => {
  const cloned = clone(values)
  const result = {}
  if (values.search) {
    result['search'] = values.search
  }
  const allResult = filters.reduce((acc, el) => {
    if (cloned[el.keyFilter]) {
      if ('range' === el.type) {
        [acc[el.keyFilter+'_min'],acc[el.keyFilter+'_max']] = cloned[el.keyFilter]
      } else {
        if (el.config?.multiple) {
          acc[el.keyFilter] = cloned[el.keyFilter].map(v => v[el.config?.label || 'slug'] || v)
        } else if ('checkbox' === el.type) {
          acc[el.keyFilter] = cloned[el.keyFilter].map(v => v[el.config?.label || 'slug'] || v)          
        } else {
          acc[el.keyFilter] = cloned[el.keyFilter][el.config?.label || 'slug']
        }
      }
    }
    return acc
  }, result)
  return allResult

}

export const removeEmptyFilters = (filters) => {
  const prepared = JSON.parse(JSON.stringify(filters))

  Object.keys(prepared).forEach(k => {
    if (typeof(prepared[k]) === 'boolean') {
      delete prepared[k]
    } else if (typeof(prepared[k]) === 'number') {
      if (!prepared[k]) {
        delete prepared[k]
      }
    } else if (isEmpty(prepared[k])) {
      delete prepared[k]
    }
  })

  return prepared
}

export const prepareParamsForUrl = (params) => {
  const prepared = JSON.parse(JSON.stringify(params))
  const shift = 1
  const page = Math.floor(prepared.pagination.offset / prepared.pagination.limit) + shift

  prepared.pagination.page = page

  if (prepared.filters) {
    prepared.filters = removeEmptyFilters(prepared.filters)
  }

  return prepared
}

export const prepareAttributes = (items, itemType = 'select') => {
  return items.map(item => {
    if (item.isDynamic) {
      item.values = item.choices.map(c => {
        const obj = {
          title: c.valueVerbose,
          slug: c.slug,
        }

        return obj
      })
      if (item.behavior === 'boolean') {
        item.trueValue = item.choices.find(c => c.valueInteger)
      }

      delete item.choices

      const singleWidgets = ['switch', 'select']

      if (singleWidgets.includes(item.type)) {
        item.config = { multiple: false }
      } else {
        item.config = { multiple: true }
      }

      item.type = itemType
    }

    return item
  })
}

export const generateTags = (selectedFilters: SelectedFilters, allFilters: FilterOption[]): Tag[] => {
  const tags = []
  if (selectedFilters.search) {
    tags.push({
        title: t('Search'),
        type: 'search',
        label: 'search',
        config: {},
        attr: {
          title: t('Search:') + ' ' + selectedFilters.search,
        },
      })
  }

  tags.concat
  const allTags = Object.keys(selectedFilters).reduce<Tag[]>((acc, key) => {
    const option = allFilters.find((el) => el.keyFilter === key)
    const value = selectedFilters[key]

    if (!option || !value) return acc

    const createTag = (val: SelectedFilterValue): Tag => ({
      title: option.title,
      type: option.type,
      label: key,
      isDynamic: option.isDynamic,
      config: option.config,
      attr: {
        title: val.title,
        label: val.slug,
      },
    })

    if (option.type === 'range' && Array.isArray(value) && value[1] !== undefined) {
      let title = `${option.title}: ${value[0]} - ${value[1]}`;
      if (option.config?.requiredFormat) {
        title = `${option.title}: ${formatNumber(value[0] as number)} - ${formatNumber(value[1] as number)}`;
      }
      acc.push({
        title: option.title,
        type: option.type,
        label: key,
        attr: {
          title,
        },
      });
    } else if (option.type === 'range-single' && typeof value === 'number') {
      acc.push({
        title: option.title,
        type: option.type,
        label: key,
        attr: {
          title: `${option.title}: ${value}`,
        },
      });
    } else if (option.type === 'switch') {
      if (!Array.isArray(value)) {
        acc.push(createTag(value))
      }
    } else if (
      option.type === 'checkbox' ||
      option.type === 'autocomplete-checkbox' ||
      (option.type === 'select' && option.config?.multiple) ||
      (option.type === 'autocomplete-select' && option.config?.multiple)
    ) {
      const values = Array.isArray(value) ? value : [value]

      values.forEach((val) => acc.push(createTag(val)))
    } else if (
      (option.type === 'select' && !option.config?.multiple) ||
      (option.type === 'autocomplete-select' && !option.config?.multiple)
    ) {
      if (!Array.isArray(value)) {
        acc.push(createTag(value))
      }
    }

    return acc
  }, [])
  return tags.concat(allTags)
}

export const clearTags = (tagToClear: Tag, selectedFilters: SelectedFilters, allFilters: FilterOption[], selectedCity?: City | null) => {
  const copiedFilters = JSON.parse(JSON.stringify(selectedFilters))

  if (tagToClear.type === 'range') {
    delete copiedFilters[`${tagToClear.label}_min`]
    delete copiedFilters[`${tagToClear.label}_max`]

    copiedFilters[tagToClear.label] = []
  } else if (tagToClear.type === 'range-single') {
    copiedFilters[tagToClear.label] = null
  } else if (tagToClear.config?.multiple) {
    copiedFilters[tagToClear.label] = copiedFilters[tagToClear.label].filter(v => {
      if (tagToClear.attr.slug) {
        return v.slug !== tagToClear.attr.slug
      }

      return v.slug !== tagToClear.attr.label
    })
  } else {
    copiedFilters[tagToClear.label] = null
  }

  if (tagToClear.label === 'city') {
    copiedFilters[tagToClear.label] = selectedCity
  }

  // require clear dependents filters
  // find dependents
  const dependents = allFilters.filter((item) => {
    return item.depends?.some((d) => d.field === tagToClear.label)
  })

  dependents.forEach(item => {
    if (item.type === 'switch' && !item.isDynamic) {
      copiedFilters[item.keyFilter] = item.default
    } else {
      copiedFilters[item.keyFilter] = null
    }
  })

  return copiedFilters
}

export const getDependValues = (depends: Dependency[], selectedFilters: SelectedFilters) => {
  return (depends || []).reduce((acc, { field, key, value }) => {
    const filterValue = selectedFilters[field]

    if (Array.isArray(filterValue)) {
      acc[key] = filterValue.map((el) => el?.[value])
    } else {
      acc[key] = filterValue?.[value]
    }

    return acc
  }, {})
}
